import React, { useEffect, useRef } from "react";

const radius = 50;
const circumference = 2 * Math.PI * radius;

const colors = {
  full: "#4caf50",
  high: "#02bfdc",
  medium: "#d8ce09",
  low: "#b6180a",
};

function getColor(percent) {
  if (percent < 25) return colors.low;
  if (percent < 50) return colors.medium;
  if (percent < 75) return colors.high;
  return colors.full;
}

const ProgressCircle = ({ complete, full, label }) => {
  const circleRef = useRef(null);
  const percent = Math.round((complete / full) * 100);

  useEffect(() => {
    if (circleRef.current) {
      const offset = circumference - (percent / 100) * circumference;
      circleRef.current.style.strokeDasharray = circumference;
      circleRef.current.style.strokeDashoffset = offset;
      circleRef.current.style.stroke = getColor(percent);
    }
  }, [percent]);

  return (
    <div className="counter-box counter-progress-box">
      <section>
        <h3 className="counter-heading">
          <span className="counter-completevalue">{complete}</span> /{" "}
          <span className="counter-fullvalue">{full}</span>
        </h3>
        <small className="counter-paragraph">{label}</small>
      </section>
      <section>
        <div className="progress-container">
          <svg width="110" height="110">
            <circle
              stroke="#ddd"
              strokeWidth="10"
              fill="transparent"
              r={radius}
              cx="60"
              cy="60"
            />
            <circle
              ref={circleRef}
              className="progress"
              strokeWidth="10"
              fill="transparent"
              r={radius}
              cx="60"
              cy="60"
           
            />
          </svg>
          <div className="progress-text">{percent}%</div>
        </div>
      </section>
    </div>
  );
};

export default ProgressCircle;